// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_1wrH_","logo":"_2LD1D"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/AlipayIcon/AlipayIcon.scss
// module id = 283
// module chunks = 0 1